import ManageEventForm from "../components/manageEvents/manageEventForm/ManageEventForm";
import * as React from "react";
import { useEffect } from "react";
import { useScrollTrigger } from "@mui/material";
import "../components/event/event.css";
import Toaster from "../components/toaster";
import { useAppDispatch, useAppSelector } from "../helpers/hooks";
import { createEvent } from "../features/eventDetails/createEventSlice";
import {
  listEvent,
  searchEvent,
  totalEventCount,
  searchEventsCount,
} from "../features/eventDetails/eventListSlice";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { fetchEventDetails } from "../features/eventDetails/eventDetailsSlice";
import { updateEvent } from "../features/eventDetails/updateEventSlice";
import { useNavigate } from "react-router-dom";


export const CreateNewEvent = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const trigger = useScrollTrigger();
  const [isLoading, setIsLoading] = React.useState(true);
  const [openToaster, setOpenToaster] = React.useState(false);
  const [disablePublish, setDisablePublish] = React.useState(false);
  const [location, setLocation] = React.useState("");
  const user = useAppSelector((state) => state.userProfile.profile);
  const [pageNo, setPageNo] = React.useState(1);
  const [toastType, setToastType] = React.useState("");
  const [toastMessage, setToastMessage] = React.useState("");
  const totelEveCount = useAppSelector(
    (state) => state.eventList.totalEventCount
  );
  const { id } = useParams();
  const eventDetails = useAppSelector(
    (state): any => state.eventDetails.details.event
  );
  const [resetForm, setResetForm] = React.useState(false);
  const [createEventBody, setCreateEventBody] = React.useState<any>({
    title: "",
    imagePath: "",
    imageName: "",
    description: "",
    location: "",
    venue: "",
    eventStartDate: "",
    eventStartTime: "",
    eventEndDate: "",
    eventEndTime: "",
    registrationStartDate: "",
    registrationStartTime: "",
    registrationEndDate: "",
    registrationEndTime: "",
    allslots: null,
    totalSlots: null,
    dept: "",
    allGoals: [],
    contact: "",
    eventSlots: [],
    createdBy:
      user.userName == "" || user.userName == undefined
        ? "ADMIN_USER"
        : user.userName,
    eventCategory: {
      id: "",
    },
  });

  useEffect(() => {
    if (id && eventDetails) {
      const mappedSlots = eventDetails.eventSlots?.map((slot: any) => ({
        startDate: slot.eventSlotStartDate || "",
        startTime: slot.eventSlotStartTime || "",
        endDate: slot.eventSlotEndDate || "",
        endTime: slot.eventSlotEndTime || "",
        allslots: String(slot.totalSlots || ""),
        slotId: slot.slotId,
      }));
  
      setCreateEventBody({
        ...eventDetails,
        eventCategory: {
          id: eventDetails.eventCategory?.id || "",
        },
        allGoals: eventDetails.allGoals || [],
        eventSlots: mappedSlots || [], 
      });
    }
  }, [eventDetails, id]);

  useEffect(() => {
    if (!id) {
      setCreateEventBody({
        title: "",
        imagePath: "",
        imageName: "",
        description: "",
        location: "",
        venue: "",
        eventStartDate: "",
        eventStartTime: "",
        eventEndDate: "",
        eventEndTime: "",
        registrationStartDate: "",
        registrationStartTime: "",
        registrationEndDate: "",
        registrationEndTime: "",
        allslots: null,
        totalSlots: null,
        dept: "",
        allGoals: [],
        contact: "",
        eventSlots: [],
        createdBy:
          user.userName == "" || user.userName == undefined
            ? "ADMIN_USER"
            : user.userName,
        eventCategory: { id: "" },
      });
    }
  }, [id]);
  const handleFormSubmission = (
    e: any,
    postBody: any,
    files: any,
    idToDelete: any,
    timeSlots: []
  ) => {
    e.preventDefault();
    let uploadFileResponse;
    setToastType("error");

    // validations
    if (postBody.contact == "") {
      setToastMessage("All fields are mandatory!");
      setOpenToaster(true);
      return null;
    } else if (postBody.title == "") {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.dept == "" || postBody.dept == undefined) {
      setToastMessage("All fields are mandatory!");
      setOpenToaster(true);
      return null;
    } else if (
      postBody.location == "" ||
      postBody.location == "Select Location"
    ) {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.allGoals == null || postBody.allGoals.length === 0) {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.venue == "") {
      setToastMessage("All fields are mandatory!");
      setOpenToaster(true);
      return null;
    } else if (postBody.eventCategory?.id == "") {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (!postBody.eventSlots || postBody.eventSlots.length === 0) {
      setToastMessage("Please add at least one slot!");
      setOpenToaster(true);
      return null;
    } else if (
      postBody.description.replace(/<(.|\n)*?>/g, "").trim().length === 0
    ) {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return false;
    } else if (!files.length && !postBody.imagePath && !id) {
      setToastMessage("Image is mandatory");
      setOpenToaster(true);
      return null;
    } else if (files.length > 5) {
      setToastMessage("More then 5 images are not allowed!");
      setOpenToaster(true);
      return null;
    } else if (!validateEventDates(postBody)) {
      return null;
    } else {
      var filter =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!filter.test(postBody.contact)) {
        setToastMessage("Please enter a valid email address");
        setOpenToaster(true);
        return false;
      } else {
        let emailDomain = postBody.contact.split("@");
        if (emailDomain[1] != "mercedes-benz.com") {
          setToastMessage("Only Mercedes Benz email is allowed!");
          setOpenToaster(true);
          return false;
        }
      }
    }

    const payloadData = (data: any) => {
      const {
        eventImages,
        feedbacks,
        qrCode,
        createdAt,
        updatedAt,
        registrationStatus,
        eventRating,
        userRegistered,
        code,
        totalHours,
        totalVolunteers,
        upcomingRegistration,
        deleteComments,
        eventCategoryName,
        completedStatus,
        deleted,
        checkInStatus,
        eventGoals,
        ...cleanData
      } = data;

      return {
        ...cleanData,
        eventCategory: {
          id: String(cleanData.eventCategory?.id || ""),
        },
      };
    };

    let formData = new FormData();
    let images: any = [];
    for (let index = 0; index < files.length; index++) {
      images.push(files[index]["name"]);
      formData.append("images", files[index], files[index].name);
    }

    const finalPayload = id ? payloadData(postBody) : postBody;

    console.log("FINAL PAYLOAD:", finalPayload);

    formData.append("event", JSON.stringify(finalPayload));
    const action = id ? updateEvent(formData) : createEvent(formData);

    dispatch(action).then((res) => {
      console.log("API RESPONSE:", res);

      if (res.meta.requestStatus == "fulfilled") {
        setDisablePublish(false);
        setToastType("success");
        setOpenToaster(true);
        setToastMessage(
          id ? "Event updated successfully!" : "Event created successfully!"
        );
        if (!id) {
          setResetForm((prev) => !prev);
        }
        if (id) {
          dispatch(fetchEventDetails(id));
        }
        setIsLoading(true);
        dispatch(totalEventCount());
        dispatch(listEvent(pageNo)).then((res) => {
          if (res.meta.requestStatus == "fulfilled") setIsLoading(false);
        });

        setCreateEventBody({
          title: "",
          imagePath: "",
          imageName: "",
          description: "",
          location: "",
          venue: "",
          eventStartDate: "",
          eventStartTime: "",
          eventEndDate: "",
          eventEndTime: "",
          registrationStartDate: "",
          registrationStartTime: "",
          registrationEndDate: "",
          registrationEndTime: "",
          allslots: null,
          dept: "",
          allGoals: [],
          eventSlots: [],
          totalSlots: null,
          contact: "",
          createdBy:
            user.userName == "" || user.userName == undefined
              ? "ADMIN_USER"
              : user.userName,
          eventCategory: {
            id: "",
          },
        });

        setLocation("");
        navigate(`/volunteering-events`);
      } else {
        setDisablePublish(false);
        setToastType("error");
        setToastMessage(
          id ? "Failed to update event!" : "Failed to create the event!"
        );
        setOpenToaster(false);
        setIsLoading(true);
        return null;
      }
    });

    setDisablePublish(true);
  };

  const validateEventDates = (data: any) => {
    let registrationStartDateTime = new Date(
      data.registrationStartDate + " " + data?.registrationStartTime
    );

    // let eventstartDateTime = dayjs(
    //   `${data.eventStartDate} ${data.eventStartTime}`
    // );
    let registrationEndDateTime = new Date(
      data.registrationEndDate + " " + data?.registrationEndTime
    );
    let eventstartDateTime = new Date(
      data.eventStartDate + " " + data?.eventStartTime
    );
    let eventEndDateTime = new Date(
      data.eventEndDate + " " + data?.eventEndTime
    );

    if (
      dayjs(registrationStartDateTime).isAfter(
        dayjs(registrationEndDateTime)
      ) ||
      dayjs(registrationStartDateTime).isSame(dayjs(registrationEndDateTime))
    ) {
      setToastMessage(
        "Registration end date must be greater then registration start date."
      );
      setOpenToaster(true);
      return false;
    } else if (
      dayjs(registrationStartDateTime).isAfter(dayjs(eventstartDateTime)) ||
      dayjs(registrationStartDateTime).isSame(dayjs(eventstartDateTime))
    ) {
      setToastMessage(
        "Registration start date must be before event start date."
      );
      setOpenToaster(true);
      return false;
    } else if (
      dayjs(registrationEndDateTime).isAfter(dayjs(eventstartDateTime)) ||
      dayjs(registrationEndDateTime).isSame(dayjs(eventstartDateTime))
    ) {
      setToastMessage("Registration end date must be before event start date.");
      setOpenToaster(true);
      return false;
    } else if (
      dayjs(eventstartDateTime).isAfter(dayjs(eventEndDateTime)) ||
      dayjs(eventstartDateTime).isSame(dayjs(eventEndDateTime))
    ) {
      setToastMessage("Event start date must be before event end date.");
      setOpenToaster(true);
      return false;
    } else return true;
  };

  useEffect(() => {
    if (id) {
      dispatch(fetchEventDetails(id));
    }
  }, [id]);

  return (
    <div>
      <ManageEventForm
        key={id ? "edit-" + id : "create"}
        title={id ? "Update Event" : "Create Event"}
        data={createEventBody}
        handleChange={setCreateEventBody}
        submitForm={handleFormSubmission}
        disablePublish={disablePublish}
        openToasterForm={openToaster}
        isLoading={isLoading}
        isEdit={!!id}
        resetForm={resetForm}
      />
      <Toaster
        openToaster={openToaster}
        toastMessage={toastMessage}
        type={toastType}
        handleToasterClose={() => setOpenToaster(false)}
      />
    </div>
  );
};

export default CreateNewEvent;
